import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-check-password',
  standalone: true,
  templateUrl: './check-password.component.html',
  styleUrls: ['./check-password.component.scss'],
  imports: [TranslatePipe],
})
export class CheckPasswordComponent {
  @Input() passwordControl: FormControl;
  @Input() newPasswordControl: FormControl | null;
  @Input() inLine = false;
}
